<template>
  <div>
    <div class="relative mt-1">
      <button
        type="button"
        class="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 sm:text-sm"
        aria-haspopup="listbox"
        aria-expanded="true"
        aria-labelledby="listbox-label"
        @click="selectorOpen = !selectorOpen"
      >
        <div class="flex items-center">
          <span
            class="inline-block h-2 w-2 flex-shrink-0 rounded-full"
            :class="{
              'bg-gray-400': selectedOption.name === 'Unassigned',
              'bg-red-400': selectedOption.name === 'High',
              'bg-orange-400': selectedOption.name === 'Medium',
              'bg-blue-400': selectedOption.name === 'Low',
            }"
            aria-hidden="true"
          />
          <span class="ml-3 block truncate">{{ selectedOption.name }} </span>
        </div>
        <span
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
        >
          <svg
            class="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </button>

      <!--
      Select popover, show/hide based on select state.
      Entering: ""
        From: ""
        To: ""
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <ul
        v-if="selectorOpen"
        class="mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-option-3"
      >
        <li
          v-for="(option, index) in definedOptions"
          id="listbox-option-0"
          :key="index"
          class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900"
          :class="{
            'bg-zuno-turquoise text-white': option.active,
            'text-gray-900': !option.active,
          }"
          role="option"
          @mouseenter="toggleActivation(index, 'on')"
          @mouseleave="toggleActivation(index)"
          @click="selectOption(index)"
        >
          <div class="flex items-center">
            <span
              class="inline-block h-2 w-2 flex-shrink-0 rounded-full"
              :class="{
                'bg-gray-400': option.name === 'Unassigned',
                'bg-red-400': option.name === 'High',
                'bg-orange-400': option.name === 'Medium',
                'bg-blue-400': option.name === 'Low',
              }"
              aria-hidden="true"
            />
            <span class="ml-3 block truncate font-normal">
              {{ option.name }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrioritySelector',

  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedIndex: {
      type: Number,
      default: () => 0,
    },
  },

  emits: ['optionSelected'],

  data() {
    const definedOptions = [...this.options].map((option) => {
      option.active = false
      return option
    })
    const selectedIndex = this.selectedIndex
    const selectedOption = definedOptions[selectedIndex]
    return {
      definedOptions,
      selectorOpen: false,
      selectedOption,
    }
  },

  methods: {
    toggleActivation(index, status = 'off') {
      this.definedOptions = this.definedOptions.map((option, i) => {
        if (i === index) {
          option.active = status === 'on'
        }
        return option
      })
    },

    selectOption(index) {
      const option = this.definedOptions[index]
      this.$emit('optionSelected', option)
      this.selectorOpen = false
      this.selectedOption = option
    },
  },
}
</script>
